// src/App.tsx

import { Routes, Route, Navigate } from "react-router-dom";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { useAuth } from "context/AuthContext";

import { DeviceProvider } from "context/DeviceContext";
import { AprendizadoProvider } from "context/AprendizadoContext";
import { UnidadeProvider } from "context/UnidadeContext";
import { ItensProvider } from "context/ItensContext";
import { FuncionarioProvider } from "context/FuncionarioContext";
import { SelectedDeviceProvider } from "context/SelectedDeviceContext";
import { NotificationProvider } from "context/NotificationContext";
import { RelatorioProvider } from "context/RelatorioContext";

const AuthenticatedApp = () => {
  return (
    <NotificationProvider>
      <SelectedDeviceProvider>
        <DeviceProvider>
          <UnidadeProvider>
            <AprendizadoProvider>
              <ItensProvider>
                <FuncionarioProvider>
                  <RelatorioProvider>
                    <Routes>
                      <Route path="/admin/*" element={<AdminLayout />} />
                      <Route path="*" element={<Navigate to="/admin/unidades" replace />} />
                    </Routes>
                  </RelatorioProvider>
                </FuncionarioProvider>
              </ItensProvider>
            </AprendizadoProvider>
          </UnidadeProvider>
        </DeviceProvider>
      </SelectedDeviceProvider>
    </NotificationProvider>
  );
};

const App = () => {
  const { isAuthenticated, user } = useAuth();

  if (user === undefined) {
    return null;
  }

  return (
    <Routes>
      {isAuthenticated ? (
        <Route path="/*" element={<AuthenticatedApp />} />
      ) : (
        <>
          <Route path="/auth/*" element={<AuthLayout />} />
          <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
        </>
      )}
    </Routes>
  );
};

export default App;
